<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      title="编辑客户上架CPE"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="采购型号">
          <a-input :value="cpeModelName" disabled />
        </a-form-item>
        <a-form-item label="对外展示型号">
          <a-input :value="displayModel" disabled />
        </a-form-item>
        <a-form-item label="通讯方式">
          <a-input :value="commModeName" disabled />
        </a-form-item>
        <a-form-item label="单价(元/台)">
          <a-input-number
            style="width: 100%"
            :min="0"
            :precision="2"
            :step="0.01"
            v-decorator="['unit_price', {
              rules: [{ required: true, message: '请输入单价' }]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findAgentsCpeProductForm, updateAgentsCpeProduct } from '@/api/agents_cpe_product'

export default {
  name: 'EditAgentsCpeProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'agents_cpe_product_edit' }),
      submitting: false,
      cpeModelName: '',
      displayModel: '',
      commModeName: ''
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findAgentsCpeProductForm(this.id).then((res) => {
        if (res.code === 0) {
          this.cpeModelName = res.data.cpe_model_name
          this.displayModel = res.data.display_model
          this.commModeName = res.data.comm_mode_name
          this.form.setFieldsValue({ unit_price: res.data.unit_price })
        }
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateAgentsCpeProduct(this.id, values).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
